// components/Draggable/sortable.module.scss
@use '@/sass/variables';

.movable {
  cursor: move;
}

// Targets the consumer's own card wrapper, which carries the tachyons `bb` border class.
:global(.bb):has([data-dragging]) {
  border-bottom-color: transparent;
}

.sortableTableDraggingRow {
  display: table;
  table-layout: fixed;
  background-color: variables.$white;
}

.sortableTableDragHandle {
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
}
